<div class="preview-buttons">
<mdc-button outlined click.trigger="preview()" style="margin-top: 10px;">Preview</mdc-button>
<mdc-button outlined click.trigger="save()" style="margin-top: 10px;">Save to DB</mdc-button>
</div>  